import Component from "@ember/component";
let componentArgs = {
  tagName: "div",
  classNames: ["discourse-root"]
};
export default Component.extend(componentArgs);